import { useContext } from 'react';
import './shared/contexts/TranslationContext.js';
import { StoreContext } from './shared/contexts/StoreContext.js';

var usePopupStore = function () {
    var popupStore = useContext(StoreContext).popupStore;
    return popupStore;
};

export { usePopupStore as u };
